<template>
  <q-badge v-bind="badge" />
</template>

<script>
import { INDETERMINATE_STATUS } from '@/consts/app'
import { CONTRACT_STATUS } from '@/consts/data/contract'

export default {
  name: 'BadgeStatusContract',
  inheritAttrs: false,
  props: {
    status: {
      type: Number,
      default: 0
    }
  },
  computed: {
    badge () {
      return {
        ...this.$attrs,
        ...CONTRACT_STATUS[this.status] || INDETERMINATE_STATUS
      }
    }
  }
}
</script>

<style scoped>

</style>
